import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { interval } from 'rxjs';
import { takeUntil, takeWhile } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { SessionStorageService } from '../../services/session-storage/session-storage.service';
import { IClaims } from '../../interfaces/shared/IClaims';
import { Router } from '@angular/router';
import IHttpResponse from '../../interfaces/shared/IHttpResponse';
export interface Notification {
  numbers: number;
}

export interface INotificationSMS {
  supplier?: number;
  tlfNumber: string;
  content: string;
}
@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  claims: IClaims;
  baseUrl = `${environment.baseUrl}`;
  apiUrl = `${environment.ApiNotify}`;
  url: string;
  read: boolean;
  numberNotification: number = 0;
  private notifications$: Subject<Notification> = new Subject<Notification>();

  constructor(
    private http: HttpClient,
    private sessionStorage: SessionStorageService,
    private router: Router
  ) {
    this.url = this.baseUrl + this.apiUrl;
    this.claims = this.sessionStorage.get('claims');
    this.read = true;

    if (this.claims) {
      this.getNotifications().subscribe(
        (res) => {
          res.data.forEach((element) => {
            element.mensajes.forEach((mensaje) => {
              if (
                mensaje.idEstadoMensaje === 3 ||
                mensaje.idEstadoMensaje === 6
              ) {
                this.read = false;
              }
            });
            if (!this.read) {
              this.numberNotification++;
            }
          });
          this.addNotificationsCount({ numbers: this.numberNotification });
          this.sessionStorage.set('notification', this.numberNotification);
          this.numberNotification = 0;
        },
        (err) => {
          console.log(err);
        }
      );
      interval(300000)
        .pipe(takeWhile(() => true))
        .subscribe(() => {
          // Condition to check if the user is on the userAdmin route
          if (
            this.router.url.includes('userAdmin') ||
            this.router.url.includes('partes')
          ) {
            this.numberNotification = 0;
            this.getNotifications().subscribe(
              (res) => {
                res.data.forEach((element) => {
                  element.mensajes.forEach((mensaje) => {
                    if (
                      mensaje.idEstadoMensaje === 3 ||
                      mensaje.idEstadoMensaje === 6
                    ) {
                      this.read = false;
                    }
                  });
                  if (!this.read) {
                    this.numberNotification++;
                  }
                });
                this.addNotificationsCount({
                  numbers: this.numberNotification,
                });
                this.sessionStorage.set(
                  'notification',
                  this.numberNotification
                );
                this.numberNotification = 0;
              },
              (err) => {
                console.log(err);
              }
            );
          }
        });
    }
  }
  reload() {
    this.getNotifications().subscribe(
      (res) => {
        res.data.forEach((element) => {
          element.mensajes.forEach((mensaje) => {
            if (
              mensaje.idEstadoMensaje === 3 ||
              mensaje.idEstadoMensaje === 6
            ) {
              this.read = false;
            }
          });
          if (!this.read) {
            this.numberNotification++;
          }
        });
        this.addNotificationsCount({ numbers: this.numberNotification });
        this.sessionStorage.set('notification', this.numberNotification);
        this.numberNotification = 0;
      },
      (err) => {
        console.log(err);
      }
    );
  }
  //falta id cliente
  getNotifications(): Observable<any> { 
    return this.http.get<any>(`${this.url}/GetNotificationbyClient`);
  }
  getNotifications$(): Observable<Notification> {
    return this.notifications$.asObservable();
  }
  addNotificationsCount(notification: Notification) {
    this.notifications$.next(notification);
  }
  createNotification(formData): Observable<any> {
    return this.http.post<any>(`${this.url}/AddNotification`, formData);
  }

  getNotificationDetail(idNotification: number): Observable<any> {
    return this.http.get<any>(`${this.url}/GetDetail/${idNotification}`);
  }

  downloadAttached(idAdjunto) {
    return this.http.get<any>(`${this.url}/GetdownloadAttached/${idAdjunto}`);
  }
  markAsRead(idNotification) {
    this.addNotificationsCount({ numbers: this.numberNotification });
    return this.http.post<any>(
      `${this.url}/SetReadnotification/${idNotification}`,
      {}
    );
  }
  replyNotification(
    idNotification: number,
    formData: FormData
  ): Observable<any> {
    return this.http.post<any>(
      `${this.url}/Replynotification/${idNotification}`,
      formData
    );
  }

  sendNotificationSMS(data: INotificationSMS) {
    return this.http.post<IHttpResponse<boolean>>(
      `${this.url}/SendSms`,
      data
    );
  }
}
